<!-- <button (click)="clickSplit()">Split</button> -->
<div class="map-icon" title="Split">
    <mat-icon class="icon-general" *ngIf="editable" (click)="clickSplit()" svgIcon="icon-split"></mat-icon>
</div>
